<template>
  <a-spin size="large" :spinning="loading">
  <div class="device-list con">
    <header>
      <h1>{{ $t('page_extranet_Machine_list') }}</h1>
      <a-button type="text" @click="refreshDeviceList">重置</a-button>
    </header>
    <div class="search">
      <a-tree-select
          style="width: 240px;margin-right: 4px"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="treeData"
          placeholder="全部"
          :value="selectedKeys"
          :load-data="onLoadData"
          :selectedKeys="selectedKeys"
          :expandedKeys="expandedKeys"
          :defaultExpandedKeys="treeExpandedKeys"
          @select="selectTree"
          v-if="isMachineTenant"
      />
      <a-select
          :value="statusSearch"
          style="width: 240px;margin-right: 4px"
          @change="handleChangeStatus"
      >
        <a-select-option value="3">
          {{ $t('page_plan_maintenance_all_states') }}
        </a-select-option>
        <a-select-option value="2">
          {{ $t('page_extranet_In_diagnosing') }}
        </a-select-option>
        <a-select-option value="1">
          {{ $t('page_extranet_Ready') }}
        </a-select-option>
        <a-select-option value="0">
          {{ $t('page_extranet_unReady') }}
        </a-select-option>
      </a-select>
      <a-input-search v-model="searchKey"
                      :placeholder="$t('keyword')"
                      :enter-button="$t('page_product_search')"
                      @search="handleChangeSearch"
      />
    </div>
    <div
        class="machine clearfix"
        v-infinite-scroll="getDeviceList"
        :infinite-scroll-disabled="loading"
        :infinite-scroll-distance="100"
        :infinite-scroll-immediate-check="false"
        id="deviceListPanel"
    >
      <ul v-if="dataList&&dataList.length" class="list-panel" >
        <li
            v-for="(machine,index) of dataList"
            :key="machine.id"
            :ml_index="index"
            :gatewayId="machine.gatewayId"
            :gatewayCode="machine.gatewayCode"
            @click="changeCurrentDevice(machine)"
            :class="{selected: machine.id === currentId}"
        >
          <template v-if="machine.userVisibleStatus === 2">
              <div v-if="isLocal(machine)"
                   class="local-extranet">
                <a-tag color="#108ee9">{{ $t('page_extranet_Local') }}</a-tag>
              </div>
            </template>

            <template v-if="machine.userVisibleStatus === 2">
              <div class="flag working">{{ $t('page_extranet_In_diagnosing') }}</div>
            </template>

            <template v-if="machine.userVisibleStatus === 1">
              <div class="flag">{{ $t('page_extranet_Ready') }}</div>
            </template>
            
            <template v-if="machine.userVisibleStatus === 0">
              <div class="flag err">{{ $t('page_extranet_unReady') }}</div>
            </template>

          <div class="pic">
            <img :src="machine.avatar" v-if="machine.avatar"/>
            <img :src="require('@/assets/images/default-device.png')" v-else alt=""/>
          </div>
          <a-tooltip :title="machine.name" placement="right" class="name ellipsis">
            {{ machine.name }}
          </a-tooltip>
          <a-tooltip :title="machine.equipmentSerialNumber" placement="right" class="serial-no ellipsis">
            {{ machine.equipmentSerialNumber }}
          </a-tooltip>
        </li>
        <li v-if="dataList.length<total" 
          @click="getDeviceList"
          style="width: 100%;height: 30px;line-height:30px;">加载更多</li>  
      </ul>
      
      <template v-else>
        <div class="empty">
          <img :src="require('@/assets/images/noDevice.png')"/>
          <p>{{ $t('page_extranet_no_device') }}</p>
        </div>
      </template>
    </div>
  </div>
  </a-spin>

</template>

<script>

import { RegionServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import {
  ExtranetServiceProxy,
  DeviceServiceProxy,
  FindDeviceStateListDto,
  CloseExtranetDTO
} from '@/service-proxies/app-v2/iot-extranet.service-proxies'

const rsp = new RegionServiceProxy()
const csp = new CustomerServiceProxy()
const extranetServiceProxy = new ExtranetServiceProxy()
const deviceServProxy = new DeviceServiceProxy()


import { getTenantInfo } from '@/utils/auth'
import { getLocalStorage } from "@/utils/storage";

import * as _ from 'lodash'

export default {
  name: 'DeviceList',
  inject:{
    extranet: "extranet"
  },
  props: {
  },
  data () {
    return {
      loading: false,
      dataList: [],
      total: 0,
      loadingTotal: 0,
      currentId: undefined,
      current: {},
      pageIndex: 1,
      pageSize: 20,
      prePageIndex: 1,
      prePageSize: 20,
      noMoreData: false,
      deviceStateList: [],
      scrollPanel: undefined,
      lastScrollTop: 0,

      refreshing: false,
      searchKey: '', // 搜索关键词
      selectNode: '',
      departmenTreeNodes: [],
      scrollTop: 0,
      statusSearch: '3',
      treeData: [], // 客户树列表
      selectedKeys: undefined,
      treeExpandedKeys: [],
      expandedKeys: [],
      customerList: [],
      tenantClass: 0,
      machineChanged: false,
      refreshDeviceStateInterval: undefined
      
    }
  },
  mounted () {
    this.tenantClass = getLocalStorage('USER_INFO')['tenant_classes'];
    this.getTreeList()
    this.resetGetDeviceList();
    this.deviceStateInterval();
  },
  beforeDestroy(){
    this.closeDeviceStateInterval();
  },
  computed:{
    isMachineTenant(){
      return this.tenantClass === 4;
    },
    codeList(){
      if(this.extranet && this.extranet.remoteConnect) {
        return this.extranet.remoteConnect.data.connectCodeList
      }
      return [];
    },
    defaultFilter(){
      return this.current.equipmentSerialNumber || this.current.name
    },
    gatewayIdList(){
      if(!this.dataList){
        return []
      }
      return this.dataList.map(c=>c.gatewayId).filter(c=>c);
    }
  },
  methods: {
    deviceStateInterval(){
      this.refreshDeviceStateInterval = setInterval(()=>{
        this.refreshListItemState();
      },10*1000)
    },
    refreshListItemState(){
      const needRefreshGatewayIdLit = this.findGatewayIdInScrollClient();

      if(!needRefreshGatewayIdLit || needRefreshGatewayIdLit.length ===0 ){
        return;
      }
      this.refreshDeviceState(needRefreshGatewayIdLit);
    },
    closeDeviceStateInterval(){
      if(this.refreshDeviceStateInterval){
        clearInterval(this.refreshDeviceStateInterval)
        this.refreshDeviceStateInterval = undefined
      }
    },
    renderDeviceState(machine){
      const deviceState = this.deviceStateList.find(c=>c.gatewayId===machine.gatewayId);
      if(deviceState){
        return deviceState.userVisibleStatus;
      }
      return machine.userVisibleStatus;
    },
    async refreshDeviceState(gatewayIdList){
      if(!gatewayIdList || !gatewayIdList.length){
        console.warn('refreshDeviceState gatewayIdList isEmpty');
        return;
      }
      const input = new FindDeviceStateListDto();
      input.gatewayIdList = gatewayIdList;
      const deviceStateList = await deviceServProxy.findDeviceStateList(input);
      this.deviceStateList = deviceStateList;

      deviceStateList.forEach(item=>{
        const device = this.dataList.find(c=>c.gatewayId===item.gatewayId);
        
        if(device){
          if(device.userVisibleStatus != item.userVisibleStatus){
            // 触发状态变更
            this.$emit('deviceStateChange', device);
          }
          device.userVisibleStatus = item.userVisibleStatus;
          device.extranetCode = item.connectCode;
          
        }
      });


    },
    async resetGetDeviceList() {
      this.resetPage();
      await this.getDeviceList()
      this.selectFirst()
    },
    async getDeviceList(){
      if(this.loading){
        console.warn('数据加载中');
        return;
      }
      if(this.noMoreData){
        return;
      }
      try{
        this.loading=true
        const params = this.createQueryParam()
        this.prePageIndex = this.pageIndex;
        this.prePageSize = this.pageSize;
        const res = await extranetServiceProxy.findDeviceList(params)
        this.total = res.totalCount
        this.loadingTotal += res.items.length;
        this.noMoreData = this.loadingTotal >= this.total;
        this.pageIndex+=1;
        this.dataList.push(...res.items)
        this.loading=false

        if(!this.currentId){
          this.selectFirst();
        }
      }
      catch(err){
        console.error({
          msg:'device list error',
          err
        });
      }
      finally{
        this.loading = false;
      }
      
      
    },
    selectFirst(){
      if(this.dataList && this.dataList.length){
        this.changeCurrentDevice(this.dataList[0])
      }
    },
    selectTree(value, row) {

      if (value.length === 0) {
        return
      }
      this.current = {}

      this.selectedKeys = value

      const dataRef = row.dataRef
      this.areaNameList = dataRef.isLeaf ? [] : [dataRef.title]
      this.customerId = dataRef.isLeaf ? dataRef.id : ''
      this.customerName =  dataRef.isLeaf ? dataRef.title : ''

      this.resetGetDeviceList();
    },
    handleChangeStatus(value) {
      this.current = {}
      this.statusSearch = value

      if (value === '3') {
        this.extranetState = ''
      } else {
        this.extranetState = value
      }
      
      this.resetGetDeviceList();
    },
    handleChangeSearch(v,e){
      
      if(this.loading){
        return;
      }
      
      if(!this.searchKey && this.defaultFilter){
        this.searchKey = this.defaultFilter
      }
      this.resetGetDeviceList();
      
    },
    // 树选择空间处理方法
    async getTreeList() {
      this.selectedKeys = undefined
      const tenant = getTenantInfo()
      const tenantCode = tenant ? tenant : '根节点'
      this.treeData = [
        {
          key: '00-00',
          id: undefined,
          value: '00-00',
          title: tenantCode,
          isLeaf: false,
          selectable: true,
          isProv: false,
          children: []
        }
      ]
      const { data } = await rsp.select()
      const children = this.expandTree(data, false, false, tenantCode)
      this.treeData[0].children = children
      this.treeExpandedKeys = ['00-00']
      this.expandedKeys = ['00-00']
    },
    expandTree(data, isLeaf, prov, pId) {
      let children = []
      if (data && data.length) {
        for (let i = 0; i < data.length; i++) {
          const node = {
            key: data[i].code,
            id: data[i].id,
            value: data[i].code,
            title: data[i].name,
            isLeaf: isLeaf,
            selectable: true,
            isProv: prov,
            pName: pId
          }
          children = children.concat(node)
        }
      }
      return children
    },
    async onLoadData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }
        const data = this.expandedKeys.find((res) => res === treeNode.dataRef.id)
        if (!data) {
          const value = treeNode.dataRef.key
          const code = treeNode.dataRef.title
          if (treeNode.dataRef.isProv) {
            csp.getCustomerByRegion(code).then((res) => {
              const children = this.expandTree(res.data, true, true, code)
              treeNode.dataRef.children = children
              this.treeData = [...this.treeData]
              this.customerList = this.customerList.concat(res.data)
            })
          } else {
            rsp.select(value).then((res) => {
              const children = this.expandTree(res.data, false, true, code)
              treeNode.dataRef.children = children
              this.treeData = [...this.treeData]
            })
          }
          this.expandedKeys.push(treeNode.dataRef.id)
        }
        resolve()
      })
    },
    changeCurrentDevice (machine) {
      this.machineChanged=true;
      this.currentId = machine.id
      this.current = {...machine}
      this.$emit('change', machine)
      if(machine.gatewayId){
        this.refreshDeviceState([machine.gatewayId])
      }
      
    },
    isLocal(item) {
      return this.codeList.find(c=>c===item.extranetCode) !== undefined;
    },
    async refreshDeviceList(){
      this.current = {};
      this.searchKey = undefined;
      this.resetGetDeviceList();
    },
    resetPage(){
      this.dataList= []
      this.noMoreData=false
      this.total=0
      this.loadingTotal= 0
      this.currentId= undefined
      this.pageIndex= 1
      this.prePageIndex= 1
    },
    createQueryParam(){
      return {
        current: this.pageIndex,
        size: this.pageSize,
        areaNameList: this.areaNameList,
        customerId: this.customerId,
        customerName: this.customerName,
        extranetState: this.extranetState,
        filter: this.searchKey,
      }
    },
    findGatewayIdInScrollClient(){
      const container = document.querySelector('#deviceListPanel')
      if(!container){
        console.warn('#deviceListPanel not exist');
        return;
      }
      if(container.children.length<=0){
        console.warn('#deviceListPanel children is empty');
        return;
      }

      const scrollPanelRect = container.getBoundingClientRect()
      const clientBottom = scrollPanelRect.bottom;
      const ulElement = container.children[0];
      const liEleList = Array.from(ulElement.children);
      const liInScrollClient = 
            liEleList.filter(c=>c.getBoundingClientRect().top<clientBottom )
                      .filter(c=>c.getBoundingClientRect().top>0);
      return liInScrollClient.map(c=>c.getAttribute('gatewayid')).filter(c=>c);

    },
    refreshItem(detail){
      if(!detail){
        return;
      }

      const device = this.dataList.find(c=>c.id===detail.id);
      if(device){
        device.userVisibleStatus = detail.userVisibleStatus;
        device.extranetCode = detail.extranetCode;
      }
    },
  }
}

</script>

<style scoped lang="less">
  @import "DeviceList";
</style>
